import { render, staticRenderFns } from "./MonthlyTaxMaybank.vue?vue&type=template&id=6702c178&scoped=true"
import script from "./MonthlyTaxMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702c178",
  null
  
)

export default component.exports